import { atom } from 'infrastructure/state/jotai.wrapper'
import { AssetUploadResultData, StageStatus } from './types'

export const uploadStatusAtom = atom<StageStatus | null>(null)
export const uploadResultAtom = atom<AssetUploadResultData | null>(null)

export const pipelineStatusAtom = atom<string>('')
export const pipelineErrorAtom = atom<string | null>(null)

export const includeImagesAtom = atom<boolean>(true)
export const includeDocumentsAtom = atom<boolean>(true)
export const includeAudioVideoAtom = atom<boolean>(true)

export const canStartAtom = atom((get) => {
  const error = get(pipelineErrorAtom)
  const status = get(uploadStatusAtom)
  return error === null && status === null
})

export const pollingTriggerAtom = atom<number>(0)
